
import CustomImage from '~/components/elements/CustomImage';

export default {
  name: 'BlogArticleAuthor',
  components: {CustomImage},
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
}
